import axios from 'axios'
import store from '~/store'
import router from '~/router'

const externalUrlPrefix = 'https://'
axios.defaults.baseURL = '/api'

// Request interceptor
axios.interceptors.request.use(request => {
  // TODO : Pros and cons of using this method to distinguish between internal and external requests
  if (request.url.startsWith(externalUrlPrefix)) {
    return request
  }
  // first we need to check for userToken, so admin can visit other user's view
  const userToken = store.getters['auth/userToken']
  if(userToken){
    request.headers.common.Authorization = `Bearer ${userToken}`
  } else {
    const token = store.getters['auth/token']
    if (token) {
      request.headers.common.Authorization = `Bearer ${token}`
    }
  }

  const locale = store.getters['lang/locale']
  if (locale) {
    request.headers.common['Accept-Language'] = locale
  }

  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request
})

// Response interceptor
axios.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      // Network error, timeout, or no response from server
      store.dispatch('snackbar/showSnack', {
        text: 'Network error. Please check your connection.',
        color: 'error',
        timeout: 3500
      })
      return Promise.reject(error)
    }

    const { status, data } = error.response

    // Example: Internal server errors
    // if (status >= 500) {
    //   store.dispatch('snackbar/showSnack', {
    //     text: data.message || i18n.t('error_alert_text'),
    //     color: 'error',
    //     timeout: 3500
    //   });
    // }

    if (status === 401 && store.getters['auth/check']) {
      store.dispatch('snackbar/showSnack', {
        text: 'Sorry! You are logged out',
        color: 'error',
        timeout: 3500
      })
      store.commit('auth/LOGOUT')
      
      // Only navigate to login if we're not already there
      if (router.currentRoute.name !== 'login') {
        router.push({ name: 'login' }).catch(() => {})
      }
    }

    if ([401, 422, 429].includes(status)) {
      store.dispatch('snackbar/showSnack', {
        text: data.message,
        color: 'error',
        timeout: 3500
      })
    }

    if (status === 403) {
      store.dispatch('permission/showPlanDialog', data.message)
    }

    return Promise.reject(error)
  }
)
